import React, { useEffect, useState } from 'react'
import { IconButton, Fade } from '@mui/material'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import { useScrollToTop } from './useScrollToTop'
import styles from './scrollToTop.module.scss'
import { useLocation } from 'react-router-dom'

const ScrollToTop: React.FC = () => {
  const [creationMode, setCreationMode] = useState(false)
  const { visible, scrollToTop } = useScrollToTop()
  const location = useLocation()

  useEffect(() => {
    setCreationMode(
      location.pathname.includes('view') ||
        location.pathname.includes('edit') ||
        location.pathname.includes('create'),
    )
  }, [location.pathname])

  return visible ? (
    <div className={styles.scrollToTop}>
      <Fade appear={visible} in={visible} timeout={300}>
        <IconButton
          onClick={scrollToTop}
          size='large'
          aria-label='scroll to top'
          className={creationMode ? styles.creationButton : ''}
        >
          <KeyboardArrowUpIcon fontSize='inherit' />
        </IconButton>
      </Fade>
    </div>
  ) : (
    <></>
  )
}

export default ScrollToTop
